<template>
	<div>
		<selected-group
			v-if="groupsForSelect.length > 0"
			:block="block"
			:groups="groupsForSelect"
			@input="handleInput"
			@handlerChange="handlerChange"
		/>
		<template v-if="groups.length === 0">
			<checkbox-type
				v-if="block.products_list_type === FORMULATE_PRODUCT_TYPE.PRODUCT_CHECKBOX"
				:products="block.products"
				@input="handleInput"
			/>
			<radio-type
				v-if="block.products_list_type === FORMULATE_PRODUCT_TYPE.PRODUCT_RADIO"
				:current="currentProduct"
				:products="block.products"
				@input="handleInput"
			/>
			<select-type
				v-if="block.products_list_type === FORMULATE_PRODUCT_TYPE.PRODUCT_SELECT"
				:products="block.products"
				@input="handleInput"
			/>
			<template v-if="block.products_list_type === FORMULATE_PRODUCT_TYPE.PRODUCT_QUANTITY">
				<product-with-count-type
					:products="block.products"
					@input="handleInput"
					@handlerChange="handlerChange"
					@handlerChangeChildsAge="handlerChangeChildsAge"
				/>
			</template>
		</template>
		<products-group
			v-else
			:groups="groups"
			:block="block"
			@input="handleInput"
		/>
	</div>
</template>

<script>
import CheckboxType from '~/components/panels/formulate/products/product-types/CheckboxType.vue';
import RadioType from '~/components/panels/formulate/products/product-types/RadioType.vue';
import ProductsGroup from '~/components/panels/formulate/products/custom-groups/ProductsGroup.vue';
import SelectType from '~/components/panels/formulate/products/product-types/SelectType.vue';
import ProductWithCountType from '~/components/panels/formulate/products/product-types/ProductWithCountType.vue';
import SelectedGroup from '~/components/panels/formulate/products/custom-groups/SelectedGroup.vue';
import { FORMULATE_PRODUCT_TYPE } from '~/utils/dictionaries';

export default {
	name: 'ProductsComponent',
	components: {
		SelectedGroup,
		ProductsGroup,
		CheckboxType,
		RadioType,
		SelectType,
		ProductWithCountType,
	},
	props: {
		block: {
			type: Object,
			required: true,
		},
		currentProduct: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			FORMULATE_PRODUCT_TYPE,
		};
	},
	computed: {
		groups() {
			if (!this.block.groups) {
				return [];
			}

			return this.block.groups.filter((group) => group !== null);
		},
		groupsForSelect() {
			if (!this.block.groups_for_select) {
				return [];
			}

			return this.block.groups_for_select.filter((group) => group !== null);
		},
	},
	methods: {
		handleInput(value) {
			this.$emit('input', value);
		},
		handlerChange(value) {
			this.$emit('handlerChange', value);
		},
		handlerChangeChildsAge(value) {
			this.$emit('handlerChangeChildsAge', value);
		},
	},
};
</script>

<style scoped>

</style>
